import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class FiltroResponsavelSharedService {
  private responsavelIdSource = new BehaviorSubject<number | 'Todos'>('Todos');
  responsavelId$ = this.responsavelIdSource.asObservable();
  
  setResponsavelId(id: number | 'Todos') {
    this.responsavelIdSource.next(id);
  }
}
